import { cn } from "utils/cn";
import { InputHTMLAttributes, useId } from "react";
import { ThresholdIndicator } from "./SegmentedControl";

interface SegmentedControlNodeProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  checked: boolean;
  value: any;
  isActive?: boolean;
  className?: string;
  outerDivClassName?: string;
  thresholdIndicator?: ThresholdIndicator,
};

const SegmentedControlNode = ({ 
  checked, onChange, className, thresholdIndicator,
  value, outerDivClassName, isActive, ...inputProps
}: SegmentedControlNodeProps) => {
  const defaultId = useId();
  const nodeId = inputProps.id || defaultId;

  return (
    // outer div for hover effect
    <div className={
      cn(
        `flex items-center justify-center p-[2px] rounded-full relative hover:ring-1 ring-inset hover:ring-primary-segmented-control-green`,
        outerDivClassName,
      )
    }>
      {
        thresholdIndicator &&(<div className={cn(
          "absolute left-1/2 bottom-0 z-10 h-[60px] flex flex-col items-start",
          thresholdIndicator?.indicatorContainerStyles,
        )}>
          <label 
            className={cn(
              "text-[10px] z-30 absolute -top-4 text-nowrap"
            )}
            id={`${nodeId}-threshold-indicator-id`}
          >
            {thresholdIndicator?.indicatorLabel}
          </label>
          <div className="border-dashed border-l border-r-0 border-y-0 relative z-30 h-[50px] w-[2px] border-typography-charcoal" />
        </div>)
      }
      <label
        className={cn(
          `flex items-center justify-center w-4 h-4 rounded-full relative border-2 border-primary-segmented-control-green z-20`,
          isActive ? `bg-primary-segmented-control-green` : `bg-white`,
          className,
        )}>
        <input
          type="radio"
          checked={checked}
          value={value}
          onChange={onChange}
          id={nodeId}
          aria-describedby={thresholdIndicator ? `${nodeId}-threshold-indicator-id` : undefined}
          className={"rounded-full w-full h-full flex items-center justify-center sr-only top-0 left-0"}
          { ...inputProps }
        />
        <div className={cn(
          "rounded-full w-[6px] h-[6px]",
          isActive ? `bg-white` : `bg-primary-segmented-control-green`
        )}/>
      </ label>
    </div>
  )
};

export default SegmentedControlNode;
